import { atom } from "recoil";
import {
  createArrayAtom,
  createBooleanAtom,
  createStringAtom
} from "./commonAtom";

// sideMenu
export const sideMenuToggleState = createBooleanAtom(
  "sideMenuToggleState",
  false
);

// pageHeader
export const isOpenShareState = createBooleanAtom("isOpenShareState", false);
export const searchToggleState = createBooleanAtom("searchToggleState", false);
export const searchState = createStringAtom("searchState", "");

// 비디오
export const youtubeIdState = atom<null | string>({
  key: "youtubeIdState",
  default: null
});

//// 언어
export const langState = createStringAtom("langState", "English");
export const langCodeState = createStringAtom("langCodeState", "en");

interface LangList {
  lang: string;
  lang_code: string;
}
export const langListState = createArrayAtom<LangList>("langListState", []);

// footer
export const ageGuidePopUpState = createBooleanAtom(
  "ageGuidePopUpState",
  false
);
